import React, { useState, useEffect, useCallback } from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import { INFLUENCERS_ENDPOINTS } from '../../../../config/api';
import { STATS_STATUSES } from '../../../../utils/constants';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Button from '../../../../shared/components/Button';
import Loader from '../../../../shared/components/Loader/Loader';
import Pagination from '../../../../../frontend/components/components/utils/Pagination';
import PropTypes from 'prop-types';
import UploadInsightSidePane from '../../offer/UploadInsightSidePane/UploadInsightSidePane';
import useBreakpoint from '../../../../shared/hooks/useBreakpoint';
import UserPostViewer from '../components/UserPostViewer';

const PendingStats = ({ offer: { user_offer:userOffer } }) => {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  if (!userOffer) return <div></div>;

  const USER_POSTS_PER_PAGE = 20;

  const statuses = [STATS_STATUSES.NEEDS_INSIGHTS,
    STATS_STATUSES.COMPLETE,
    STATS_STATUSES.UNDER_REVIEW,
    STATS_STATUSES.RETRIEVING_POST];
  const variants = {
    [STATS_STATUSES.NEEDS_INSIGHTS]: 'warning',
    [STATS_STATUSES.COMPLETE]: 'success',
    [STATS_STATUSES.UNDER_REVIEW]: 'danger',
    [STATS_STATUSES.RETRIEVING_POST]: 'secondary',
  };

  const [state, setState] = useState({
    userPosts: [],
    totalPages: 0,
    currentPage: 1,
    userPostsTotalCount: 0,
    loading: false
  });

  const statsStatus = userOffer.user_posts_by_stats_status;
  const [uploadInsightOpen, setUploadInsightOpen] = useState(false);
  const [selectedUserPost, selectUserPost] = useState(null);

  const loadUserPost = (page) => {
    setState({ ...state, loading: true });

    axios.get(
      INFLUENCERS_ENDPOINTS.PAGINATED_USER_POST.GET(userOffer.id, { page })
    ).then(({ data }) => {
      const {
        total_pages,
        user_posts,
        total_count
      } = data;

      setState({
        ...state,
        currentPage: page,
        userPosts: user_posts,
        totalPages: total_pages,
        userPostsTotalCount: total_count,
        loading: false
      });
    }).catch((e) => {
      console.error(e);
      setState({ ...state, loading: false });
    });
  };

  useEffect(() => { loadUserPost(state.currentPage) }, []);

  const changePage = useCallback((page) => { loadUserPost(page); }, [state]);

  return (
    <div className={breakpoint == 'xs' ? 'ml-3' : ''}>
      <Row>
        {breakpoint !== 'xs' ?
          <h3 className="mb-4-5">{t('influencers.pages.campaign.status.pending_stats')}</h3> :
          <h4 className="mb-4-5">{t('influencers.pages.campaign.status.pending_stats')}</h4>}

        <p>{t('influencers.pages.campaign.status.desc_pending_stats')}</p>

        <hr className='mt-0 mb-6' style={{ width: '100%' }}/>

        {breakpoint !== 'xs' ?
          <h3 className="mb-4-5">{t('influencers.pages.campaign.status.detected_content')}</h3> :
          <h4 className="mb-4-5">{t('influencers.pages.campaign.status.detected_content')}</h4>}

        <Col xs={12} md={6} className="pl-0">
          <div className="d-inline-flex mb-2 mb-sm-0">
            {statuses.map(status => {
              if (statsStatus[status] && statsStatus[status] > 0) {
                return <Col key={status} className="ml-0">
                  <Row>
                    <Badge className="ml-0 mb-0" variant={variants[status]}>
                      {t(`influencers.pending_stats.status.${status}`)}
                    </Badge>
                  </Row>
                  <Row><p className='ml-1 text-3'>{statsStatus[status]}</p></Row>
                </Col>;
              }
            })}
          </div>
        </Col>
      </Row>
      <Row>
        {state.loading ?
          <Loader loading={state.loading} /> :
          <React.Fragment>
            {state.userPosts && state.userPosts.map((userPost) => <Col md={4} className="pl-0 mb-3" key={userPost.id}>
              <Card className="mb-2">
                <Card.Header>
                  <Badge className="m-0" variant={variants[userPost.stats_status]}>
                    {t(`influencers.pending_stats.status.${userPost.stats_status}`)}
                  </Badge>
                  <h5 className="card-header-title">
                    {userPost.formatted_post_type}
                  </h5>
                </Card.Header>
                <Card.Body>
                  <UserPostViewer userPost={userPost} />
                  <div className="text-3">
                    {userPost.caption}
                  </div>
                </Card.Body>
                <Card.Footer>
                  <div className='d-flex flex-column align-items-end'>
                    {userPost.stats_status === STATS_STATUSES.NEEDS_INSIGHTS &&
                      <div className="mb-2">
                        <Button className="p-0" variant="tertiary" href="#" size="sm" onClick={() => { selectUserPost(userPost); setUploadInsightOpen(true); }}>
                          {t("influencers.content_approval.links.upload")}
                          <i className="fal fa-arrow-right icon-right"></i>
                        </Button>
                      </div>
                    }
                  </div>
                </Card.Footer>
              </Card>
            </Col>)}
            {
              state.userPostsTotalCount > USER_POSTS_PER_PAGE && 
              <Col xs="12" className="text-center mt-4">
                <Pagination
                  currentPage={state.currentPage}
                  lastPage={state.totalPages}
                  fetchData={changePage}
                />
              </Col>
            }
          </React.Fragment>
        }
      </Row>
      {selectedUserPost && <UploadInsightSidePane
        isPaneOpen={uploadInsightOpen}
        onRequestClose={() => { setUploadInsightOpen(false); }}
        userPost={selectedUserPost}
        userOfferId={userOffer.id}
      />}
    </div>
  );
};

PendingStats.propTypes = {
  offer: PropTypes.object.isRequired
};

export default PendingStats;